// Ctrl/Cmd+Enter does a dialog's main action, wherever the focus is inside
// the dialog (or on nothing yet). Off while `enabled` is false.

import { useEffect, useRef } from "react";

export function useModEnter(action: () => void, enabled = true): void {
  const latest = useRef(action);
  latest.current = action;
  useEffect(() => {
    if (!enabled) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "Enter" || !(e.metaKey || e.ctrlKey) || e.defaultPrevented) return;
      e.preventDefault();
      latest.current();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [enabled]);
}
